export const EXOTITLE = 'EXOCET';
export const MOBILE_BREAKPOINT = 500;
export const BREAKPOINT_HIDE = 50;
export const BREAKPOINT_SHOW_SMALL = 200; 

export const HOME = 'Accueil';
export const TEAM = 'Nos Équipes'
export const SPONSOR = 'Commanditaires'
export const GALLERY = 'Galerie';
export const CONTACT = 'Nous Rejoindre'

export const HOME_OPACITY = 0.8;
export const BASE_OPACITY = 1;